// src/pages/hair-centers/hair-centers.component.jsx
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createAppointment } from '../../redux/appointment/appointment.actions';
import './hair-centers.styles.scss';

const HairCenters = ({ createAppointment }) => {
  const whatsappLink = "https://wa.me/923224314712";
  const phoneNumber = "+923224314712";

  // ===== BOOKING FORM STATE =====
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [bookingData, setBookingData] = useState({
    name: '',
    phone: '',
    address: '',
    city: 'Rawalpindi',
    date: '',
    time: '',
    service: 'hair-unit',
    branch: 'Rawalpindi',
    message: ''
  });
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ===== BRANCH DATA =====
  const branches = [
    {
      id: 1,
      code: "0001",
      name: "Hairline Branch",
      city: "Rawalpindi",
      address: "Asim Plaza, 1st Floor, Office 24",
      phone: "+923224314712",
      isMain: true
    },
    {
      id: 2,
      code: "0002",
      name: "Hairpoint Branch",
      city: "Rawalpindi",
      address: "Rawalpindi, Pakistan",
      phone: "+923224314712"
    },
    {
      id: 3,
      code: "0003",
      name: "Hairbar Branch",
      city: "Karachi",
      address: "Siraj Road, Karachi",
      phone: "+923224314712"
    },
    {
      id: 4,
      code: "0004",
      name: "Natural Hair Branch",
      city: "Multan",
      address: "Navashar Chowk, Near Punjab Bank",
      phone: "+923224314712"
    },
    {
      id: 5,
      code: "0005",
      name: "Hairstyle Branch",
      city: "Lahore",
      address: "Gulberg 2, Near Corvit System",
      phone: "+923224314712"
    }
  ];

  // ===== EXPERT DATA =====
  const expert = {
    name: "Amir Pasha",
    title: "Senior Consultant",
    experience: "35+ Years",
    image: "https://i.ibb.co/gMfg9Rcg/amir.jpg",
    description: "A pioneer in hair restoration with 35+ years of excellence, Mr. Amir Pasha has helped over 10,000 clients regain their confidence. His masterful approach to custom hair solutions and non-surgical replacement sets him apart as Pakistan's leading hair restoration expert."
  };

  // ===== BOOKING FORM HANDLERS =====
  const handleBookingChange = (e) => {
    const { name, value } = e.target;
    setBookingData(prev => ({ ...prev, [name]: value }));
  };

  const getAppointmentMessage = (data) => {
    const serviceLabels = {
      'hair-unit': 'Hair Unit / Patch',
      'hair-transplant': 'Hair Transplant',
      'consultation': 'Free Consultation'
    };

    return `🦁 CRISPY HAIR SOLUTION - APPOINTMENT BOOKING
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
👤 Name: ${data.name}
📱 Phone: ${data.phone}
📍 Address: ${data.address}
🏙️ City: ${data.city}
🏢 Branch: ${data.branch}
📅 Date: ${data.date || 'Not specified'}
⏰ Time: ${data.time || 'Not specified'}
🏥 Service: ${serviceLabels[data.service] || data.service}
📝 Message: ${data.message || 'No additional message'}
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Please confirm this appointment.`;
  };

  const sendWhatsAppMessage = (data) => {
    const message = getAppointmentMessage(data);
    window.open(`${whatsappLink}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const appointmentData = {
      ...bookingData,
      bookingDate: new Date().toISOString(),
      status: 'pending',
      source: 'hair-centers-page'
    };

    const result = await createAppointment(appointmentData);

    if (result.success) {
      sendWhatsAppMessage(bookingData);
      setBookingSuccess(true);
      setIsSubmitting(false);
      
      setTimeout(() => {
        setBookingSuccess(false);
        setShowBookingForm(false);
        setBookingData({
          name: '',
          phone: '',
          address: '',
          city: 'Rawalpindi',
          date: '',
          time: '',
          service: 'hair-unit',
          branch: 'Rawalpindi',
          message: ''
        });
      }, 4000);
    } else {
      alert('Error saving appointment: ' + result.error);
      setIsSubmitting(false);
    }
  };

  const handleDirectWhatsApp = () => {
    if (!bookingData.name || !bookingData.phone) {
      alert('Please fill in Name and Phone fields first');
      return;
    }
    sendWhatsAppMessage(bookingData);
  };

  return (
    <div className="hair-centers-page">
      {/* ===== HERO SECTION ===== */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Crispy Hair Replacement Centers</h1>
          <p className="hero-subtitle">Surgical hair replacement is available exclusively at our main Rawalpindi branch, offering advanced, permanent hair restoration solutions performed by experienced surgeons with proven results.Non-surgical hair replacement is available at all five branches across Pakistan</p>
          <p className="booking-note">
            ⚠️ Important: All visits are strictly by appointment only.<br />
            Please book your free consultation online before coming to our center.<br />
            Walk-in clients will not be entertained without prior confirmation.<br />
            Book your slot now to avoid disappointment.
          </p>
          <button 
            className="btn-book"
            onClick={() => setShowBookingForm(true)}
          >
            📅 Book Appointment
          </button>
        </div>
      </section>

      {/* ===== BOOKING MODAL ===== */}
      {showBookingForm && (
        <div className="booking-modal" onClick={() => !isSubmitting && setShowBookingForm(false)}>
          <div className="booking-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={() => setShowBookingForm(false)} disabled={isSubmitting}>×</button>
            <h2>📅 Book Appointment</h2>
            <p>Fill in your details and we'll contact you</p>

            {bookingSuccess ? (
              <div className="booking-success">
                <span>✅</span>
                <h3>Appointment Saved!</h3>
                <p>We will contact you shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleBookingSubmit}>
                <input type="text" name="name" placeholder="Full Name *" value={bookingData.name} onChange={handleBookingChange} required disabled={isSubmitting} />
                <input type="tel" name="phone" placeholder="Phone Number *" value={bookingData.phone} onChange={handleBookingChange} required disabled={isSubmitting} />
                <input type="text" name="address" placeholder="Address *" value={bookingData.address} onChange={handleBookingChange} required disabled={isSubmitting} />
                
                <select name="city" value={bookingData.city} onChange={handleBookingChange} required disabled={isSubmitting}>
                  <option value="Rawalpindi">Rawalpindi</option>
                  <option value="Islamabad">Islamabad</option>
                  <option value="Lahore">Lahore</option>
                  <option value="Karachi">Karachi</option>
                  <option value="Multan">Multan</option>
                </select>

                <select name="branch" value={bookingData.branch} onChange={handleBookingChange} required disabled={isSubmitting}>
                  {branches.map((b) => (
                    <option key={b.id} value={b.name}>{b.name} - {b.city}</option>
                  ))}
                </select>

                <div className="form-row">
                  <input type="date" name="date" value={bookingData.date} onChange={handleBookingChange} required disabled={isSubmitting} />
                  <select name="time" value={bookingData.time} onChange={handleBookingChange} required disabled={isSubmitting}>
                    <option value="">Time</option>
                    <option value="09:00 AM">09:00 AM</option>
                    <option value="10:00 AM">10:00 AM</option>
                    <option value="11:00 AM">11:00 AM</option>
                    <option value="12:00 PM">12:00 PM</option>
                    <option value="01:00 PM">01:00 PM</option>
                    <option value="02:00 PM">02:00 PM</option>
                    <option value="03:00 PM">03:00 PM</option>
                    <option value="04:00 PM">04:00 PM</option>
                    <option value="05:00 PM">05:00 PM</option>
                    <option value="06:00 PM">06:00 PM</option>
                  </select>
                </div>

                <select name="service" value={bookingData.service} onChange={handleBookingChange} required disabled={isSubmitting}>
                  <option value="hair-unit">Hair Unit / Patch</option>
                  <option value="hair-transplant">Hair Transplant</option>
                  <option value="consultation">Free Consultation</option>
                </select>

                <textarea name="message" placeholder="Additional Message" value={bookingData.message} onChange={handleBookingChange} rows="2" disabled={isSubmitting} />

                <button type="submit" className="btn-submit" disabled={isSubmitting}>
                  {isSubmitting ? 'Saving...' : '📤 Book Appointment'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* ===== EXPERT SECTION ===== */}
      <section className="expert-section">
        <div className="expert-header">
          <h2>Meet Our Expert</h2>
        </div>
        <div className="expert-card">
          <div className="expert-image">
            <img src={expert.image} alt={expert.name} />
            <div className="expert-badge">35+ Years Experience</div>
          </div>
          <div className="expert-info">
            <h3>{expert.name}</h3>
            <p className="expert-title">{expert.title}</p>
            <p className="expert-description">{expert.description}</p>
            <div className="expert-tags">
              <span>✅ 35+ Years</span>
              <span>✅ 10,000+ Clients</span>
              <span>✅ Custom Solutions</span>
            </div>
            <button className="btn-whatsapp" onClick={() => window.open(whatsappLink, '_blank')}>
              💬 Consult Now
            </button>
          </div>
        </div>
      </section>

      {/* ===== BRANCHES SECTION ===== */}
      <section className="branches-section">
        <div className="branches-header">
          <h2>📍 Our Branches</h2>
          <p>Serving customers across Pakistan</p>
        </div>
        <div className="branches-grid">
          {branches.map((branch) => (
            <div className={`branch-card ${branch.isMain ? 'main' : ''}`} key={branch.id}>
              {branch.isMain && <span className="main-tag">⭐ Main</span>}
              <h3>{branch.name}</h3>
              <span className="branch-city">{branch.city}</span>
              <p className="branch-address">{branch.address}</p>
              <a href={`tel:${phoneNumber}`} className="branch-phone">📞 {branch.phone}</a>
              <button className="btn-branch-book" onClick={() => setShowBookingForm(true)}>
                📅 Book
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* ===== SERVICES SECTION ===== */}
      <section className="services-section">
        <div className="services-header">
          <h2>🎯 Our Services</h2>
        </div>
        <div className="services-grid">
          <div className="service-card">
            <span className="service-icon">🏥</span>
            <h3>Surgical Replacement</h3>
            <p>Permanent hair restoration</p>
            <span className="service-tag">Rawalpindi Only</span>
          </div>
          <div className="service-card">
            <span className="service-icon">💆</span>
            <h3>Non-Surgical</h3>
            <p>No surgery, natural results</p>
            <span className="service-tag">All Branches</span>
          </div>
          <div className="service-card">
            <span className="service-icon">🧵</span>
            <h3>Hair Units</h3>
            <p>Custom hair systems</p>
          </div>
          <div className="service-card">
            <span className="service-icon">💇</span>
            <h3>Hair Extensions</h3>
            <p>100% human hair</p>
          </div>
        </div>
      </section>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  createAppointment: (data) => dispatch(createAppointment(data))
});

export default connect(null, mapDispatchToProps)(HairCenters);